import type { Vehicle } from '../types/vinvrmsearch.types';
import type { VehicleDerivative } from '../types/manualsearch.types';
import { isVehicle } from './checkVehicleType';

// Helper function to get display information from either Vehicle or VehicleDerivative
export const getVehicleDisplayInfo = (vehicle: Vehicle | VehicleDerivative) => {
    if (isVehicle(vehicle)) {
        const d = vehicle.derivative;
        return {
            year:
                d?.first_year_of_manufacture ??
                (vehicle.date_of_first_registration
                    ? new Date(vehicle.date_of_first_registration).getFullYear()
                    : 'Unknown Year'),
            make: d?.make?.name ?? 'Unknown Make',
            model: d?.model?.name ?? 'Unknown Model',
            variant: d?.short_name ?? vehicle.full_description ?? 'Unknown Variant',
            vin: vehicle.vin || 'Unknown',
            registration:
                vehicle.current_status?.vrm ??
                vehicle.current_status?.formatted_vrm ??
                'Unknown',
        };
    } else {
        // It should be a VehicleDerivative, othwise fallback to unknowns
        return {
            year: vehicle.first_year_of_manufacture ?? 'Unknown Year',
            make: vehicle.make?.name ?? 'Unknown Make',
            model: vehicle.model?.name ?? 'Unknown Model',
            variant: vehicle.short_name ?? 'Unknown Variant',
            vin: 'N/A',
            registration: 'N/A',
        };
    }
};
